module.exports = __webpack_public_path__ + "static/marble-edge-b85ca56237cd29588cd46132a7a81c6d.png";